import React from 'react';
import { Box, Container, Heading, Text, VStack, HStack, Button, Badge } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaArrowRight, FaCalendar } from 'react-icons/fa';

const MotionBox = motion(Box);

const ExperiencedCTA = ({ data }) => {
  return (
    <Box
      py={{ base: 16, md: 20 }}
      bgGradient="linear(to-br, brand.700, brand.900, accent.green)"
      position="relative"
      overflow="hidden"
    >
      {/* Background effects */}
      <Box
        position="absolute"
        top="0"
        right="0"
        w="300px"
        h="300px"
        bg="accent.gold"
        opacity="0.1"
        borderRadius="full"
        filter="blur(80px)"
      />
      <Box
        position="absolute"
        bottom="0"
        left="0"
        w="400px"
        h="400px"
        bg="accent.green"
        opacity="0.15"
        borderRadius="full"
        filter="blur(100px)"
      />

      <Container maxW="container.lg">
        <MotionBox
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <VStack spacing={8} textAlign="center" color="white">
            <Badge
              px={4}
              py={2}
              bg="accent.gold"
              color="brand.800"
              fontSize="sm"
              fontWeight="700"
              borderRadius="full"
            >
              {data.badge}
            </Badge>
            
            <Heading
              size="2xl"
              fontWeight="900"
              maxW="3xl"
              lineHeight="1.2"
            >
              {data.title}
            </Heading>
            
            <Text fontSize="xl" opacity={0.9} maxW="2xl">
              {data.description}
            </Text>

            <HStack spacing={4} pt={4} flexWrap="wrap" justify="center">
              <Button
                as="a"
                href={data.enrollButton.href}
                variant="solid"
                size="lg"
                h="60px"
                px={8}
                rightIcon={<FaArrowRight />}
                boxShadow="0 8px 30px rgba(16,185,129,0.4)"
                _hover={{
                  transform: 'translateY(-2px)',
                  boxShadow: '0 12px 40px rgba(16,185,129,0.5)',
                }}
              >
                {data.enrollButton.text}
              </Button>
              
              <Button
                variant="outline"
                size="lg"
                h="60px"
                px={8}
                borderColor="white"
                color="white"
                as="a"
                href={data.consultationButton.href}
                _hover={{
                  bg: 'whiteAlpha.200',
                  transform: 'translateY(-2px)',
                }}
                leftIcon={<FaCalendar />}
              >
                {data.consultationButton.text}
              </Button>
            </HStack>

            <Text fontSize="sm" opacity={0.8} pt={4}>
              {data.seatsText}
            </Text>
          </VStack>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default ExperiencedCTA;